import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { supabase } from "../Services/supabaseClient";
import { useCompany } from "../context/CompanyContext";

export default function BillingCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refreshCompanyContext } = useCompany();

  const [status, setStatus] = useState("verifying"); // verifying | success | failed
  const [message, setMessage] = useState("Verifying your payment…");

  useEffect(() => {
    const run = async () => {
      const qs = new URLSearchParams(location.search);
      const reference = qs.get("reference");

      if (!reference) {
        setStatus("failed");
        setMessage("Missing payment reference.");
        return;
      }

      try {
        setStatus("verifying");
        setMessage("Confirming transaction with Paystack…");

        const { data, error } = await supabase.functions.invoke(
          "paystack-verify",
          {
            body: { reference },
          }
        );

        if (error) throw error;

        if (data?.status === "success") {
          setStatus("success");
          setMessage("Payment successful ✅ Your plan is now active.");

          if (typeof refreshCompanyContext === "function") {
            await refreshCompanyContext();
          }

          // take user back to billing or dashboard
          setTimeout(() => navigate("/billings"), 1200);
        } else {
          setStatus("failed");
          setMessage(
            "Payment not completed. If you were charged, contact support."
          );
        }
      } catch (e) {
        console.error(e);
        setStatus("failed");
        setMessage("Unable to verify payment right now. Please refresh.");
      }
    };

    run();
  }, [location.search, navigate, refreshCompanyContext]);

  return (
    <div style={{ padding: 20 }}>
      <h2>Billing Callback</h2>
      <p>{message}</p>
      {status === "failed" && (
        <button onClick={() => (window.location.href = "/billings")}>
          Back to Billing
        </button>
      )}
    </div>
  );
}
